import { type Common } from './common.js';
import { type PaginatedQueryOptions } from './models/pagination/PaginatedQueryOptions.type.js';
import { type PaginationResponse } from './models/pagination/PaginationResponse.type.js';
import {
  type CreateValues,
  type FindAllOptions,
  type UpdateValues,
  type VisitReason,
} from './models/visitReason.js';

export class API {
  common: Common;
  baseEndpoint = '/visit-reasons';

  constructor(common: Common) {
    this.common = common;
  }

  async findOneById(id: string): Promise<VisitReason> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.getJSON(url);
  }

  async findAllPaginated(
    options: PaginatedQueryOptions<FindAllOptions>
  ): Promise<PaginationResponse<VisitReason>> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async findAllStandardValues(): Promise<string[]> {
    const url = this.common.constructPath(`${this.baseEndpoint}/standard-values`);
    return await this.common.getJSON(url);
  }

  async create(values: CreateValues): Promise<VisitReason> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, values);
  }

  async update(id: string, values: UpdateValues): Promise<VisitReason> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.patchJSON(url, values);
  }

  async remove(id: string): Promise<{ success: true }> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.deleteJSON(url);
  }
}
